module.exports = __webpack_public_path__ + "img/champion-show-title.36ebe5c4.png";